import { colors } from 'assets/theme';
import { LitField, TftfTable, TftfTableBody, TftfTableHead } from 'assets/theme/StyledComponents';
import React, { useEffect, useState } from 'react'
import { subscribeListener, unsubscribeListener } from 'redux/ably/sagas';

const config = [
  { label:'ES 1', instrument: 'VPMES1'},
  { label:'ES 5', instrument: 'VPMES5'},
  { label:'ES 60', instrument: 'VPMES60'},
  { label:'NQ 1', instrument: 'VPMNQ1'},
  { label:'NQ 5', instrument: 'VPMNQ5'},
  { label:'NQ 60', instrument: 'VPMNQ60'},
]

interface IStmomoRowData {
  stmomo: string
}

interface IModelRowData {
  Close: number
  Percentile10: number
  Percentile90: number
  nc: number
  Signal10_action: number
  Signal90_action: number
  SignalStop_action: number
  Tftf90_open: number
  Tftf10_open: number
}

const getStmomoColor = (stmomo: string): string => {
  switch (stmomo) {
    case 'BUY':
      return colors.accents.good.base
    case 'SELL':
      return colors.accents.bad.base
    case 'STOPOUT':
      return colors.accents.aware.base
  }
  return ''
}

export const ModelOutputRow: React.FunctionComponent<{ id: number, sym: string, label: string}> = ({ id, sym, label }) => {
  const [stmomoRowData, setStmomoRowData] = useState<IStmomoRowData | undefined>()
  const [modelRowData, setModelRowData] = useState<IModelRowData | undefined>()
  const [fileredModelRowData, setFileredModelRowData] = useState<IModelRowData | undefined>()

  useEffect(() => {
    subscribeListener(`model:${sym}:1tick`, id, ({ data }) => {
      if (Array.isArray(data) && data.length > 0) {
        setModelRowData(data[data.length -1])
      }
    })
    if (sym !== 'VPMES1' && sym !== 'VPMNQ1') {
      subscribeListener(`model:${sym}F:1tick`, id, ({ data }) => {
        if (Array.isArray(data) && data.length > 0) {
          setFileredModelRowData(data[data.length -1])
        }
        })
    }
    subscribeListener(`stmomo:${sym}`, id, ({ data }) => {
      setStmomoRowData(data)
    })
    return () => {
      if (sym !== 'VPMES1' && sym !== 'VPMNQ1') {
        unsubscribeListener(`model:${sym}F:1tick`, id)
      }
      unsubscribeListener(`model:${sym}:1tick`, id)
      unsubscribeListener(`stmomo:${sym}`, id)
    }
  }, [id, sym])

  // const getIndicator = () => {
  //   if (stmomoRowData && modelRowData) {
  //     switch(stmomoRowData.stmomo) {
  //       case 'BUY':
  //         if (modelRowData.Tftf90_open !== undefined) {
  //           return modelRowData.Tftf90_open.toFixed(2)
  //         }
  //         break;
  //       case 'SELL':
  //           if (modelRowData.Tftf10_open !== undefined) {
  //             return modelRowData.Tftf10_open.toFixed(2)
  //           }
  //         break;
  //     }
  //   }
  //   return ''
  // }
  let [action, actionColor] = ['', '']
  let [filteredAction, filteredActionColor] = ['', '']
  if (modelRowData) {
    [action, actionColor] = modelRowData.Signal10_action === 1 ? ['BUY', colors.accents.good.base] : modelRowData.Signal90_action === -1 ? ['SELL', colors.accents.bad.base] : modelRowData.SignalStop_action === -2 ? ['STOP', colors.accents.aware.base]  : ['', '']
  }
  if (fileredModelRowData) {
    [filteredAction, filteredActionColor] = fileredModelRowData.Signal10_action === 1 ? ['BUY', colors.accents.good.base] : fileredModelRowData.Signal90_action === -1 ? ['SELL', colors.accents.bad.base] : fileredModelRowData.SignalStop_action === -2 ? ['STOP', colors.accents.aware.base]  : ['', '']
  }

  let [indicator, color] = ['', '']
  if (modelRowData && modelRowData.nc) {
    [indicator, color] = modelRowData.nc > 0 ? ['+', colors.accents.good.base] : ['', colors.accents.bad.base];
  }

  return (
    <tr key={sym}>
      <td>{label}</td>
      {
        stmomoRowData ?
        <td style={{ textAlign: 'center', color: getStmomoColor(stmomoRowData.stmomo) }}>{stmomoRowData.stmomo}</td>
        :
        <td />
      }
      {
        modelRowData ?
        <React.Fragment>
          <td style={{ textAlign: 'right', color }}>{modelRowData.Close !== undefined ? modelRowData.Close.toFixed(2) : ''}</td>
          <td style={{ textAlign: 'right', color }}>{indicator}{modelRowData.nc !== undefined ? modelRowData.nc.toFixed(2) : ''}</td>
          <td style={{ textAlign: 'right', color }}>{indicator}{(modelRowData.Close !== modelRowData.nc ? 100 * modelRowData.nc / (modelRowData.Close - modelRowData.nc) : 0).toFixed(2)}</td>
          <td style={{ textAlign: 'right' }}>{modelRowData.Percentile10 !== undefined ? modelRowData.Percentile10.toFixed(2) : '' }</td>
          <td style={{ textAlign: 'right' }}>{modelRowData.Percentile90 !== undefined ? modelRowData.Percentile90.toFixed(2) : '' }</td>
          {/* <td style={{ textAlign: 'right' }}>{getIndicator()}</td> */}
          <td style={{ textAlign: 'center' }}><LitField backgroundColor={actionColor}>{action}</LitField></td>
        </React.Fragment>
        :
        <td colSpan={7} />
      }
      {
        fileredModelRowData ?
        <td style={{ textAlign: 'center' }}><LitField backgroundColor={filteredActionColor}>{filteredAction}</LitField></td>
        :
        <td />
      }
    </tr>
  )
}

export const ModelOutput: React.FunctionComponent<{id: number}> = ({ id }) => {
  return (
    <TftfTable>
      <TftfTableHead>
        <tr>
          <th>Instrument</th>
          <th style={{ textAlign: 'center' }}>Short Term Trend</th>
          <th style={{ textAlign: 'right' }}>Current Price</th>
          <th style={{ textAlign: 'right' }}>Change</th>
          <th style={{ textAlign: 'right' }}>%Change</th>
          <th style={{ textAlign: 'right', opacity: 1, color: colors.accents.good.base }}>Oversold</th>
          <th style={{ textAlign: 'right', opacity: 1, color: colors.accents.bad.base }}>Overbought</th>
          {/* <th style={{ textAlign: 'right' }}>TFTF Indicator</th> */}
          <th style={{ textAlign: 'center' }}>Trade Signal (L)</th>
          <th style={{ textAlign: 'center' }}>Trade Signal (F)</th>
        </tr>
      </TftfTableHead>
      <TftfTableBody>
        {
          config.map(item => <ModelOutputRow key={item.instrument} label={item.label} id={id} sym={item.instrument} />)
        }
      </TftfTableBody>
    </TftfTable>
  );
};
